import RegistryLinkSection from './registry-link-section'

export default RegistryLinkSection
